// Responsive Slick Arrows for Get Inspired

function getTitleHeight() {
    return document.querySelector('.get-inspired__title').offsetTop;
}

function getTitleWidth() {
    return document.querySelector('.get-inspired__title').clientWidth;
}

function positionArrows(arrow) {

    arrow.style.top = `${getTitleHeight() + 10}px`
    arrow.style.left = `${getTitleWidth() - 24}px`

    if (arrow.classList.contains('slick-prev')) {
        arrow.style.left = `${getTitleWidth() - 54}px`
    }
}

function checkForParent() {
    setTimeout(() => {
        var arrows = document.querySelectorAll('.slick-arrow');

        arrows.forEach(function(arrow) {
           if (arrow.parentNode.classList.contains('get-inspired__container')) {
               positionArrows(arrow)
           }
        })
    }, 1000)
}

window.addEventListener('resize', checkForParent);
$(function() {
    checkForParent();
});
